/* Ambient Home — product page (swipe gallery + sticky add to cart) */
(function () {
  'use strict';

  /* ---- gallery: native scroll-snap track, buttons/thumbs just scroll it ---- */
  var gal = document.querySelector('[data-pdp-gallery]');
  if (gal) {
    var track = gal.querySelector('[data-pdp-track]');
    var slides = [].slice.call(gal.querySelectorAll('[data-pdp-slide]'));
    var thumbs = [].slice.call(gal.querySelectorAll('[data-pdp-thumb]'));
    var counter = gal.querySelector('[data-pdp-i]');
    var i = 0;

    function mark(n) {
      i = n;
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
      if (counter) counter.textContent = String(i + 1);
      var th = thumbs[i];
      if (th && th.parentNode.scrollWidth > th.parentNode.clientWidth) {
        th.parentNode.scrollTo({ left: th.offsetLeft - 40, behavior: 'smooth' });
      }
    }
    function go(n) {
      if (!slides.length || !track) return;
      n = (n + slides.length) % slides.length;
      track.scrollTo({ left: n * track.clientWidth, behavior: 'smooth' });
      mark(n);
    }

    if (track) {
      var raf = null;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          var n = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          if (n !== i && n >= 0 && n < slides.length) mark(n);
        });
      }, { passive: true });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(i + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(i - 1); }
      });
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-i'), 10) || 0); });
    });
    var prev = gal.querySelector('[data-pdp-prev]');
    var next = gal.querySelector('[data-pdp-next]');
    if (prev) prev.addEventListener('click', function () { go(i - 1); });
    if (next) next.addEventListener('click', function () { go(i + 1); });
  }


  /* ---- delivery window: 3–5 working days from today, shown as real dates ---- */
  var eta = document.querySelector('[data-pdp-eta]');
  if (eta) {
    var days = ['недела', 'понеделник', 'вторник', 'среда', 'четврток', 'петок', 'сабота'];
    var addWork = function (from, n) {
      var d = new Date(from.getTime());
      while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; }
      return d;
    };
    var fmt = function (d) { return days[d.getDay()] + ' ' + d.getDate() + '.' + (d.getMonth() + 1) + '.'; };
    var now = new Date();
    var a = eta.querySelector('[data-eta-a]'), b = eta.querySelector('[data-eta-b]');
    if (a && b) { a.textContent = fmt(addWork(now, 3)); b.textContent = fmt(addWork(now, 5)); eta.hidden = false; }

    /* free gift note: orders of 10.000 ден or more get the Мозаик shoe rack free (cart adds it automatically) */
    var gift = document.createElement('p');
    gift.className = 'pdp__eta pdp__gift';
    gift.innerHTML = '<span><span aria-hidden="true">🎁</span> За нарачки над <b>10.000 ден</b> добивате <a href="/products/chevlarnik-mozaik-3-nivoa-od-tkaenina-i-metal-mat-crn" style="text-decoration:underline">чевларник Мозаик</a> бесплатно.</span>';
    eta.parentNode.insertBefore(gift, eta.nextSibling);
  }

  /* ---- reassurance right under the buttons (risk reducers next to the decision point) ---- */
  var addForm = document.getElementById('ah-add');
  var ASSURE = '<span>Плаќање при достава</span><span>Бесплатна достава</span><span>Враќање до 14 дена</span>';
  if (addForm && addForm.querySelector('[name="add"]')) {
    var as = document.createElement('p');
    as.className = 'pdp__assure';
    as.innerHTML = ASSURE;
    addForm.parentNode.insertBefore(as, addForm.nextSibling);
  }

  /* ---- add to cart without leaving the page: slide-up cart panel ---- */
  var GIFT_VID = 44022909042806, GIFT_MIN = 1000000;
  var money = function (c) { return Math.round(c / 100).toLocaleString('de-DE') + ' ден'; };
  var api = function (url, body) {
    return fetch(url, body === undefined ? { headers: { Accept: 'application/json' } } : {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
  };
  /* keep the free-gift rule in step with the cart (same rule as the cart page) */
  var syncGift = function (cart) {
    var base = 0, line = 0;
    cart.items.forEach(function (it, k) {
      if (it.properties && it.properties._gift === '1') line = k + 1; else base += it.final_line_price;
    });
    cart._base = base;
    if (base >= GIFT_MIN && !line) {
      return api('/cart/add.js', { items: [{ id: GIFT_VID, quantity: 1, properties: { _gift: '1' } }] })
        .then(function () { return api('/cart.js'); }).then(function (c) { c._base = base; return c; })
        .catch(function () { return cart; });
    }
    if (base < GIFT_MIN && line) {
      return api('/cart/change.js', { line: line, quantity: 0 }).then(function (c) { c._base = base; return c; })
        .catch(function () { return cart; });
    }
    return Promise.resolve(cart);
  };

  var css = document.createElement('style');
  css.textContent =
    '.pdp__assure{display:flex;flex-wrap:wrap;justify-content:center;gap:4px 14px;margin:10px 0 0;font-size:12.5px;font-weight:600;color:var(--green,#2e7d32)}' +
    '.pdp__assure span::before{content:"\\2713";margin-right:5px}' +
    '.ahd{position:fixed;inset:0;z-index:1000}.ahd[hidden]{display:none}' +
    '.ahd__bg{position:absolute;inset:0;background:rgba(0,0,0,.45);opacity:0;transition:opacity .2s}' +
    '.ahd__p{position:absolute;left:0;right:0;bottom:0;background:var(--bg,#fff);border-radius:16px 16px 0 0;padding:18px 18px calc(18px + env(safe-area-inset-bottom,0px));box-shadow:0 -10px 40px rgba(0,0,0,.2);transform:translateY(100%);transition:transform .25s ease;max-height:90vh;overflow:auto}' +
    '.ahd.is-on .ahd__bg{opacity:1}.ahd.is-on .ahd__p{transform:none}' +
    '@media(min-width:900px){.ahd__p{left:auto;top:0;width:400px;border-radius:0;transform:translateX(100%)}}' +
    '.ahd__h{display:flex;align-items:center;justify-content:space-between;margin-bottom:14px}.ahd__h strong{font-size:16px;color:var(--green,#2e7d32)}' +
    '.ahd__x{background:none;border:0;font-size:26px;line-height:1;cursor:pointer;padding:4px 8px}' +
    '.ahd__i{display:flex;gap:12px;align-items:center;padding-bottom:14px;border-bottom:1px solid var(--line,#e5e5e5)}' +
    '.ahd__i img{width:72px;height:72px;object-fit:contain;border-radius:var(--r-m,10px);background:var(--cream,#f6f4ef)}' +
    '.ahd__t{margin:0;font-size:14px;line-height:1.35;font-weight:500}.ahd__pr{margin:4px 0 0;font-size:14px;font-weight:700}' +
    '.ahd__g{margin:12px 0 0;padding:10px 12px;border-radius:var(--r-m,10px);background:var(--cream,#f6f4ef);font-size:13px;line-height:1.4}' +
    '.ahd__g.is-ok{background:rgba(46,125,50,.08);color:var(--green,#2e7d32)}' +
    '.ahd__s{display:flex;justify-content:space-between;margin:14px 0;font-size:15px}' +
    '.ahd__b{display:grid;gap:10px}.ahd__b .btn{width:100%;text-align:center}' +
    '.ahd__more{display:block;width:100%;margin-top:6px;background:none;border:0;padding:10px;font-size:14px;font-weight:600;text-decoration:underline;cursor:pointer}' +
    '.ahd .pdp__assure{margin-top:6px}';
  document.head.appendChild(css);

  var dr = null;
  var buildDrawer = function () {
    dr = document.createElement('div');
    dr.className = 'ahd';
    dr.hidden = true;
    dr.innerHTML =
      '<div class="ahd__bg" data-ahd-x></div>' +
      '<div class="ahd__p" role="dialog" aria-modal="true" aria-label="Додадено во кошничка">' +
        '<div class="ahd__h"><strong>✓ Додадено во кошничка</strong><button class="ahd__x" type="button" data-ahd-x aria-label="Затвори">×</button></div>' +
        '<div class="ahd__i"><img alt="" width="72" height="72"><div><p class="ahd__t"></p><p class="ahd__pr"></p></div></div>' +
        '<p class="ahd__g"></p>' +
        '<div class="ahd__s"><span class="ahd__n"></span><strong class="ahd__tot"></strong></div>' +
        '<div class="ahd__b">' +
          '<button class="btn btn--p btn--big" type="button" data-ahd-go>Продолжи кон нарачка</button>' +
          '<a class="btn btn--o" href="/cart">Види ја кошничката</a>' +
        '</div>' +
        '<button class="ahd__more" type="button" data-ahd-x>Продолжи со купување</button>' +
        '<p class="pdp__assure">' + ASSURE + '</p>' +
      '</div>';
    document.body.appendChild(dr);
    dr.addEventListener('click', function (e) {
      if (e.target.closest('[data-ahd-x]')) closeDrawer();
      if (e.target.closest('[data-ahd-go]')) {
        e.target.closest('[data-ahd-go]').disabled = true;
        api('/cart.js').then(syncGift).then(function () { location.href = '/checkout'; }, function () { location.href = '/cart'; });
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && dr && !dr.hidden) closeDrawer(); });
  };
  var closeDrawer = function () {
    dr.classList.remove('is-on');
    document.documentElement.style.overflow = '';
    setTimeout(function () { dr.hidden = true; }, 250);
  };
  var openDrawer = function (item, cart) {
    if (!dr) buildDrawer();
    var img = dr.querySelector('.ahd__i img');
    if (item.image) { img.src = item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=200'; img.hidden = false; } else { img.hidden = true; }
    dr.querySelector('.ahd__t').textContent = item.product_title;
    dr.querySelector('.ahd__pr').textContent = (item.quantity > 1 ? item.quantity + ' × ' : '') + money(item.final_price);
    var base = cart._base || 0, g = dr.querySelector('.ahd__g');
    if (base >= GIFT_MIN) { g.className = 'ahd__g is-ok'; g.textContent = '🎁 Чевларникот Мозаик е ваш бесплатно — додаден е во кошничката.'; }
    else { g.className = 'ahd__g'; g.textContent = '🎁 Уште ' + money(GIFT_MIN - base) + ' до бесплатен чевларник Мозаик.'; }
    dr.querySelector('.ahd__n').textContent = 'Вкупно (' + cart.item_count + (cart.item_count === 1 ? ' производ)' : ' производи)');
    dr.querySelector('.ahd__tot').textContent = money(cart.total_price);
    document.querySelectorAll('.hdr__cart').forEach(function (a) {
      var n = a.querySelector('.cart-n');
      if (!n) { n = document.createElement('span'); n.className = 'cart-n'; a.appendChild(n); }
      n.textContent = cart.item_count;
    });
    dr.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(function () { requestAnimationFrame(function () { dr.classList.add('is-on'); }); });
    var go = dr.querySelector('[data-ahd-go]'); go.disabled = false; go.focus({ preventScroll: true });
  };

  var ajaxAdd = function (form, submitter) {
    var buyNow = submitter && submitter.name === 'return_to';
    var fd = new FormData(form);
    fd.delete('return_to');
    var btns = [].slice.call(form.querySelectorAll('button[type="submit"]'));
    btns.forEach(function (b) { b.disabled = true; });
    var item;
    return fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (it) { item = it; return api('/cart.js'); })
      .then(syncGift)
      .then(function (cart) {
        btns.forEach(function (b) { b.disabled = false; });
        if (buyNow) { location.href = '/checkout'; return; }
        openDrawer(item, cart);
      })
      .catch(function () {
        btns.forEach(function (b) { b.disabled = false; });
        if (buyNow) { var h = document.createElement('input'); h.type = 'hidden'; h.name = 'return_to'; h.value = '/checkout'; form.appendChild(h); }
        HTMLFormElement.prototype.submit.call(form);   /* fall back to the normal page flow */
      });
  };
  if (window.fetch && window.FormData) {
    if (addForm) addForm.addEventListener('submit', function (e) { e.preventDefault(); ajaxAdd(addForm, e.submitter); });
    var stickyForm = document.querySelector('[data-pdp-sticky] form');
    if (stickyForm) stickyForm.addEventListener('submit', function (e) { e.preventDefault(); ajaxAdd(stickyForm, e.submitter); });
  }

  /* ---- sticky add to cart: on whenever the main button is off screen (also before it is reached) ---- */
  var bar = document.querySelector('[data-pdp-sticky]');
  var atc = document.querySelector('[data-pdp-atc]');
  if (bar && atc && 'IntersectionObserver' in window) {
    bar.hidden = false;
    document.documentElement.classList.add('pdp-sticky-on');
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        bar.classList.toggle('is-on', !en.isIntersecting);
      });
    }, { rootMargin: '0px 0px -20px 0px' }).observe(atc);
  }
})();
